import { EntityRefLink, useEntity } from '@backstage/plugin-catalog-react';
import { Content, InfoCard } from '@backstage/core-components';
import { Grid, Typography } from '@material-ui/core';
import { applicationPageTranslationRef } from '../../translation/application-page/application-page';
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';

export const ApplicationForm = () => {
    const { entity } = useEntity();
    const { t } = useTranslationRef(applicationPageTranslationRef);

    const {
        number,
        division,
        category,
        lifecycle,
        manager,
        itManager,
    } = entity.spec ?? {};

    return (
        <Content noPadding>
            <InfoCard title={t('applicationForm.title')}>
                <form>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Grid container spacing={3}>

                                {/* Nombre de la Aplicación */}
                                <Grid item xs={6} sm={4}>
                                    <Typography variant="subtitle2" color="textSecondary">{t('applicationTableColumns.name')}</Typography>
                                    <Typography variant="body1">{`${number as string} - ${entity.metadata.title}`}</Typography>
                                </Grid>

                                {/* Division */}
                                <Grid item xs={6} sm={4}>
                                    <Typography variant="subtitle2" color="textSecondary">{t('applicationTableColumns.division')}</Typography>
                                    {division ? <EntityRefLink
                                        entityRef={division as string}
                                        defaultKind={'Division'}
                                        defaultNamespace="default"
                                    /> : <Typography variant="body1">
                                        {division as string || '—'}
                                    </Typography>}
                                </Grid>

                                {/* Lifecycle */}
                                <Grid item xs={6} sm={4}>
                                    <Typography variant="subtitle2" color="textSecondary">{t('applicationTableColumns.lifecycle')}</Typography>
                                    <Typography variant="body1">{lifecycle as string || '—'}</Typography>
                                </Grid>

                                {/* Category */}
                                <Grid item xs={6} sm={4}>
                                    <Typography variant="subtitle2" color="textSecondary">{t('applicationTableColumns.category')}</Typography>
                                    <Typography variant="body1">{category as string || '—'}</Typography>
                                </Grid>

                                {/* Manager */}
                                <Grid item xs={6} sm={4}>
                                    <Typography variant="subtitle2" color="textSecondary">{t('applicationTableColumns.manager')}</Typography>
                                    {manager ? <EntityRefLink
                                        entityRef={manager as string}
                                        defaultKind={'User'}
                                        defaultNamespace="default"
                                    /> : <Typography variant="body1">
                                        {manager as string || '—'}
                                    </Typography>}
                                </Grid>

                                {/* IT Manager */}
                                <Grid item xs={6} sm={4}>
                                    <Typography variant="subtitle2" color="textSecondary">{t('applicationTableColumns.itManager')}</Typography>
                                    {itManager ? <EntityRefLink
                                        entityRef={itManager as string}
                                        defaultKind={'User'}
                                        defaultNamespace="default"
                                    /> : <Typography variant="body1">
                                        {itManager as string || '—'}
                                    </Typography>}
                                </Grid>

                            </Grid>
                        </Grid>
                    </Grid>
                </form>
            </InfoCard>
        </Content>
    );
};